module.exports = __webpack_public_path__ + "static/media/logo2.e204b9db.svg";